module.exports = __webpack_public_path__ + "img/9.28436c86.png";